<template>
    <b-dropdown :text=selectedCompanyName>
        <b-dropdown-item v-for="company in companies" :key="company.id" v-on:click="companySelected(company)">{{company.name}}</b-dropdown-item>
    </b-dropdown>
</template>

<script>
import { globalStore } from "../../shared/helpers";
import { companyService } from "../../shared/services";

export default {
    data() {
        return {
            selectedCompany: null,
            companies: null,
        };
    },     
    computed: {
        loginState : function() {
        return globalStore.loginState;
        },
        selectedCompanyName() {
            if(!this.companies) return "Välj företag";
            if(!this.selectedCompany && this.companies.length > 1) return "Välj företag";

            return this.selectedCompany.name;
        }
    },
    mounted() {
        companyService.getAll().then(p => {
            this.companies = p;

            if(p.length == 1) 
            {
                this.companySelected(p[0]);
            }
        }).catch(() => {
            this.ShowToast("Fel", "Ett okänt fel uppstod när företag skulle hämtas", "error")
            })
    },
    methods:{
        companySelected(company) {
            this.selectedCompany = company;
            this.$emit("onCompanySelected", company);
        }
    }

}
</script>

<style>

</style>
